import { ViewModel,View } from "binder"
import { CssClassListExtractor } from "src/formBuilder/formBuilder/utilities/cssClassListExtractor";
import { IStaticValueProvider } from "../IStaticValueProvider";
import  { ClassListEditorView } from "./classListEditor-view"

export class ClassListEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        
        this.suggestions = CssClassListExtractor.GetClassList();
    }
    GetDefaultView(): View <ViewModel> {
        return new ClassListEditorView();
    }
    public getTypeId(): string {
        return "VM-33FADE89-3A91-4712-81CC-396BC8A2611C"
    }

    
    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
    public set suggestions(v: string[]) { this._suggestions = v; } public get suggestions(): string[] { return this._suggestions;} private _suggestions: string[];

    setValue(v: string) {
        this.value = v;
    }
    getValue(): string {
        return this.value;
    }

    requestConfirm() {
    }

}
